import React, { Component } from 'react';
import { Button, Form, InputGroup, FormText, FormControl, Table } from 'react-bootstrap';
import {withRouter, Redirect, Link} from 'react-router-dom';
import {browserHistory} from 'react-router'
import apiFetch from "../utils/apiFetch";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPause, faPen, faPlay, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {faEye} from "@fortawesome/free-solid-svg-icons/faEye";

class Statistics extends Component {

    constructor(props) {
        super(props);
        this.state = {
            stats: null
        }
        this.loadStats();
    }

    loadStats = () => {
        apiFetch('stats.get').then((result) => {
            console.log(result);
            if (!result.success) {
                this.setState({need_login: true});
                window.location.replace("/auth");
            } else {
                console.log('auth is okey')
                this.setState({stats: result.stats})
            }
        })
    }

    render() {
        return (
            <div className="col-md-12">
                <h3>Статистика</h3>
                {this.state.stats && <React.Fragment>
                    Количество пользователей - {this.state.stats.users_count}<br/>
                    Количество активных альбомов - {this.state.stats.albums_count}
                    <hr/>
                    <Table striped bordered hover>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Количество лайков от пользователей</th>
                            <th>Ссылка на альбом</th>
                            <th>Контакты фотографа</th>
                            <th>Действия</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.stats && this.state.stats.albums_by_rating.map((album) => {
                            let info_link = '/album/info/'+album.id;
                            return <React.Fragment>{album ? <tr key={album.id}>
                                <td>{album.id}</td>
                                <td>{album.rating}</td>
                                <td>{album.album_link}</td>
                                <td>{album.photographer_contact}</td>
                                <td>
                                    <Link to={info_link}><FontAwesomeIcon icon={faEye}/></Link>
                                </td>
                            </tr> : null }</React.Fragment>
                        })}
                        </tbody>
                    </Table>
                </React.Fragment>}
            </div>
        );
    }
}

export default withRouter(Statistics);







// WEBPACK FOOTER //
// ./src/components/Statistics.js